import {Component, Input} from '@angular/core';
import {
  FilterService,
  BaseFilterCellComponent,
} from '@progress/kendo-angular-grid';

@Component({
    selector: 'app-form-type-filter',
    template: `
    <kendo-dropdownlist
      [data]='data'
      (valueChange)='onChange($event)'
      [defaultItem]='defaultItem'
      [value]="localStorageValue !== undefined ? localStorageValue : selectedValue"
      [valuePrimitive]='true'
      [textField]='textField'
      [valueField]='valueField'
    >
    </kendo-dropdownlist>
  `,
    standalone: false
})
export class FormTypeFilterComponent extends BaseFilterCellComponent {
  public get selectedValue(): any {
    const filter = this.filterByField(this.valueField);
    return filter ? filter.value : null;
  }

  @Input() public override filter: any;
  @Input() public data: any[];
  @Input() public textField: string;
  @Input() public valueField: string;
  public localStorageValue;

  public get defaultItem(): any {
    return {
      [this.textField]: 'Select item...',
      [this.valueField]: null,
    };
  }

  constructor(filterService: FilterService) {
    super(filterService);
    if (localStorage.getItem('formTypeFilter') !== null) {
      this.localStorageValue = localStorage.getItem('formTypeFilter');
    } else {
      this.localStorageValue = undefined;
    }
  }

  public onChange(value: any): void {
    if (value !== null) {
      localStorage.setItem('formTypeFilter', value);
    } else {
      localStorage.removeItem('formTypeFilter');
    }
    this.applyFilter(
      value === null // value of the default item
        ? this.removeFilter('form_type') // remove the filter
        :
        this.updateFilter({
          // add a filter for the field with the value
          field: 'form_type',
          operator: 'eq',
          value,
        })
    ); // update the root filter
  }
}
